import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <footer
        className="page_footer ds ms s-py-50 s-pb-lg-60 s-pb-xl-60"
        style={{ marginTop: 30 }}
      >
        <div className="container">
          <div className="row align-center">
            <div className="col-xl-4 col-lg-3 text-lg-left" style={{ marginTop: 50 }}>
              <Link to="/">
                <img
                  src="./Images/tulika-logo.jpg"
                  alt="Website Logo"
                  width={150}
                  style={{ borderRadius: 12 }}
                />
              </Link>
              <div className="divider-60 divider-lg-0" />
            </div>

            {/* <div className="widget widget_nav_menu">
                <h3>Services</h3>
                <ul className="menu">
                  <li className="menu-item">
                    <a href="#">Customise Paintings</a>
                  </li>
                  <li className="menu-item">
                    <a href="#">Home Decor</a>
                  </li>
                  <li className="menu-item">
                    <a href="#">Modern Abstracts</a>
                  </li>
                  <li className="menu-item">
                    <a href="#">Living Room Painting</a>
                  </li>
                  <li className="menu-item">
                    <a href="#">Buddha Painting</a>
                  </li>
                </ul>
              </div> */}

            <div className="col-xl-4 col-lg-4 align-self-start text-lg-left" style={{ marginTop: 30 }}>
              <div className="widget widget_nav_menu">
                <h3>Quick Links</h3>
                <ul className="menu">
                  <li className="menu-item">
                    <Link to="/about-us">About</Link>
                  </li>
                  <li className="menu-item">
                    <Link to="/disclaimer">Disclaimer</Link>
                  </li>
                  <li className="menu-item">
                    <Link to="/privacy-policy">Privacy Policy</Link>
                  </li>
                  <li className="menu-item">
                    <Link to="/refund-policy">Refund Policy</Link>
                  </li>
                  <li className="menu-item">
                    <Link to="/faq">FAQ</Link>
                  </li>
                  <li className="menu-item">
                    <Link to="/contact-us">Contact Us</Link>
                  </li>
                </ul>
              </div>
              <div className="divider-60 divider-lg-0" />
            </div>
            <div className="col-xl-4 col-lg-4 align-self-start text-lg-left" style={{ marginTop: 30 }}>
              <div className="widget widget_text">
                <h3>Contact Info</h3>
                {/* <p>Address: B-106, Rohini Sector 26, New Delhi-110085</p> */}
                <p>Gmail: tulikartworks@gmail.com</p>
                <p>Number: +91-9869261077</p>
                <p className="social-icon">
                  <a
                    target="_blank"
                    href="https://www.facebook.com/people/Tulika/100067604133894/?mibextid=ZbWKwL"
                    className="fa fa-facebook"
                    title="facebook"
                  />
                  <a
                    target="_blank"
                    href="https://www.instagram.com/tulika.art.creations/"
                    className="fa fa-instagram"
                    title="instagram"
                  />
                  <a

                    href="https://wa.me/9869261077"
                    className="fa fa-whatsapp"
                    title="WhatsApp"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                  </a>
                  <a
                    target="_blank"
                    href="https://www.youtube.com/@rishabh_nishad"
                    className="fa fa-youtube-play"
                    title="youtube"
                  />
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
